<template>
  <div class="head-page">
    <Header :title="$t('member.system_message')" />
    <div style="height: calc(100vh - 60px);overflow-y: auto;">
      <van-pull-refresh
        :pulling-text="$t('common.pulling')"
        :loosing-text="$t('common.loosing')"
        :loading-text="$t('common.loading')"
        v-model="refreshing"
        @refresh="onRefresh"
      >
        <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="$t('common.nomore')"
          :loading-text="$t('common.loading')"
          :error-text="$t('common.errortxt')"
          @load="onLoad"
        >
          <div v-if="list.length > 0">
            <div class="my-notify" v-for="(item, index) in list" :key="index">
              <van-row @click="toshow(item)">
                <van-col :span="3">
                  <van-icon
                    v-if="item.status && item.status == 1"
                    class="notify-icon"
                    name="envelop-o"
                    size="28px"
                    color="#d74e5a"
                  />
                  <van-icon
                    v-else
                    class="notify-icon"
                    name="envelop-o"
                    size="28px"
                    color="#02c289"
                  />
                </van-col>
                <van-col :span="12"
                  ><div class="van-ellipsis title">
                     {{ item.title }}
                  </div></van-col
                >
                <van-col :span="9" class="txt-right"
                  ><div class="time">{{ item.addtime }}</div></van-col
                >
              </van-row>
            </div>
          </div>
          <van-empty  v-else :description="$t('common.nodata')" />
        </van-list>
      </van-pull-refresh>
    </div>
    <van-popup v-model="show" round :closeable="true">
      <div class="notify-show">
        <div class="title">
          {{ item.title }}
        </div>
        <div class="time txt-right">
          {{ item.addtime }}
        </div>
        <div class="icon" v-if="item.imgs">
          <img :src="item.imgs" />
        </div>
        <div class="content" v-html="item.content" />
      </div>
    </van-popup>
  </div>
</template>

<script>
import Header from "@/components/Header";
export default {
  name: "MyNotify",
  components: {
    Header,
  },
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      page: 1,
      limit: 10,
      show:false,
      item:{}
    };
  },
  mounted() {
    // this.onLoad()
  },
  methods: {
    onLoad() {
      this.getData();
    },
    async getData() {
      await this.$http({
        method: "post",
        url: "getNoticeList",
        data: {
          page: this.page,
          limit: this.limit,
        },
      }).then((res) => {
        this.refreshing = false;
        this.loading = false
        if (res && res.data && res.data.list) {
          res.data.list.forEach((element) => {
            this.list.push(element);
          });
          if (res.data.list.length < this.limit) {
            this.finished = true;
          } else {
            this.page += 1;
            this.finished = false;
          }
        } else {
          this.finished = true;
        }
      });
    },
    onRefresh() {
      this.page = 1;
      this.list = [];
      this.finished = false;
      this.loading = true;
      this.onLoad();
    },
    async toshow(item){
      await this.$http({
        method: "post",
        url: "getNoticeList",
        data: {
          id:item.id,
          page: 1,
          limit: 1,
        },
      }).then((res) => {
        item.status = 2
        this.item = res.data.list[0]
      });
      this.show = true
    }
  },
};
</script>

<style>
</style>
